export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}log/log`;

    return $resource(url, null, {
        search: {
            method: 'POST',
            url: `${url}/search`
        },
        logs: {
            method: 'GET',
            url: `${url}/logs`
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/ApplicationLog/index.js